import { render } from "./xiaoshoue.vue?vue&type=template&id=57419902&scoped=true"
import script from "./xiaoshoue.vue?vue&type=script&lang=js"
export * from "./xiaoshoue.vue?vue&type=script&lang=js"

import "./xiaoshoue.vue?vue&type=style&index=0&id=57419902&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57419902"]])

export default __exports__